import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { IonicModule } from '@ionic/angular';

@Component({
    standalone: true,
    selector: 'lib-toggle-password',
    templateUrl: './toggle-password.component.html',
    styleUrls: ['./toggle-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IonicModule],
})
export class TogglePasswordComponent {
    @Output() public readonly showingPasswordChanged = new EventEmitter<boolean>();
    public showingPassword = false;
}
